import * as BABYLON from 'babylonjs';
import VisualComponent from './VisualComponent';

class URLButton extends VisualComponent {
    getType() { return "URLButton"; }

    constructor( { id } = {} ) {
        super( { id });
    }

    construct( context, prefab ) {
        const base = super.construct( context, prefab );

        if( prefab.getURL() ) {
            var url = prefab.getURL();
           
            this.mesh.actionManager = new BABYLON.ActionManager(this.scene);
            this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function(event){

                // Open special 3D Viewer
                if(prefab.getURL() == "HFSpecial"){
                    window.dispatchEvent(new CustomEvent("openViewer3DHFGroup"));
                
                // Open default Website
                }else{
                    if(prefab.getdisplayInternally() == "true")
                        window.dispatchEvent(new CustomEvent("openURL",{detail:{url: url,showURL: prefab.getdisplayUrl() == "true"}}));
                    else
                        window.open(url, "_blank");                  
                }
            }));
            
        }
        //this.mesh.parent = base;
        return base;
    }
    

}

export default URLButton;
